module.exports = __webpack_public_path__ + "static/toxicogx-f9d0f38845e4ac24fde64d08aa8e9629.png";